<mat-card class="mb-5">
  <mat-card-content>
    <form [formGroup]="stepThirdFormGroup" *transloco="let ta; read 'accountInfos'">

      @if (isLoadingUserPersonalInfo) {
        <app-loader diameter="40" class="m-auto"/>
      } @else {

        @if (shouldSimplifyForm) {
          <p class="fs-16 mb-5 wb-bw">Lorsque vos billets seront vendus alors vous recevrez un email à <b>{{userInfo.email}}</b></p>
        } @else {
          <div class="form" formGroupName="userProfile">
            @if (!!userInfo?.UserBankingInfo?.mangoKYCId && userInfo?.UserBankingInfo?.mangoKYCLevel !== 'STRONG') {
              <p
                class="error fs-16">
                {{ ta('yourIDIsBeingChecked') }}<br>
                {{ ta('ifYouEditYouCancelIDCheck') }}<br>
                {{ ta('personalDataMustBeSameAsID') }}
              </p>
            }
            <mat-form-field class="form__field mb-4">
              <mat-label>{{ta('firstname')}}</mat-label>
              <input
                formControlName="firstname"
                matInput
                required
                [appTrim]="true"
                >
              @if (getError('userProfile', 'firstname')) {
                <mat-error>{{ 'formErrors.' + getError('userProfile', 'firstname') | transloco }}</mat-error>
              }
            </mat-form-field>
            <mat-form-field class="form__field mb-4" subscriptSizing="dynamic">
              <mat-label>{{ta('lastname')}}</mat-label>
              <input
                formControlName="lastname"
                matInput
                required
                [appTrim]="true"
                >
              @if (specificProcess === processType.Selling) {
                <mat-hint>
                  {{ ta('needFullNameForMoneyTransfer') }}
                </mat-hint>
              }
              @if (getError('userProfile', 'lastname')) {
                <mat-error>{{ 'formErrors.' + getError('userProfile', 'lastname') | transloco }}</mat-error>
              }
            </mat-form-field>
            <mat-form-field class="form__field mb-4" subscriptSizing="dynamic">
              <mat-label>{{ta('email')}}</mat-label>
              <input [appTrim]="true" formControlName="email" matInput type="email" email required>
              <mat-hint>{{ ta('toSendYouTransactionDetails') }}</mat-hint>
              @if (getError('userProfile', 'email')) {
                <mat-error>{{ 'formErrors.' + getError('userProfile', 'email') | transloco }}</mat-error>
              }
            </mat-form-field>
            @if (!hidePhone) {
              <p class="mb-3">{{ ta('mobilePhone') }}</p>
              <app-phone-form-field
                class="form__field --full mb-4"
                [controlName]="'mobilePhone'"
                [form]="userProfileForm"
                [formModel]="userInfo"
                [validators]="specificProcess === processType.WaitList ? ['required'] : []"
                [options]="{
                  label: 'accountInfos.mobilePhone'
                }"
                >
              </app-phone-form-field>
            }
            <p class="mb-3">{{ ta('dateOfBirth') }}</p>
            <div formGroupName="birthday" class="form --one-line-xs full-width">
              <mat-form-field class="form__field --day">
                <mat-label>{{ta('day')}}</mat-label>
                <mat-select matNativeControl formControlName="day" (selectionChange)="onDateChange()" required>
                  @for (day of availableDays; track day) {
                    <mat-option [value]="day">{{day}}</mat-option>
                  }
                </mat-select>
                @if (getError('userProfile', 'birthday', 'day')) {
                  <mat-error>{{ 'formErrors.' + getError('userProfile', 'birthday', 'day') | transloco }}</mat-error>
                }
              </mat-form-field>
              <mat-form-field class="form__field" *transloco="let tcm; read 'calendar.months'">
                <mat-label>{{ta('month')}}</mat-label>
                <mat-select matNativeControl formControlName="month" (selectionChange)="onDateChange()" required>
                  @for (month of availableMonths; track month; let i = $index) {
                    <mat-option [value]="i+1">{{tcm(month)}}</mat-option>
                  }
                </mat-select>
                @if (getError('userProfile', 'birthday', 'month')) {
                  <mat-error>{{ 'formErrors.' + getError('userProfile', 'birthday', 'month') | transloco }}</mat-error>
                }
              </mat-form-field>
              <mat-form-field class="form__field">
                <mat-label>{{ta('year')}}</mat-label>
                <mat-select matNativeControl formControlName="year" (selectionChange)="onDateChange()" required>
                  @for (year of availableYears; track year) {
                    <mat-option [value]="year">{{year}}</mat-option>
                  }
                </mat-select>
                @if (getError('userProfile', 'birthday', 'year')) {
                  <mat-error>{{ 'formErrors.' + getError('userProfile', 'birthday', 'year') | transloco }}</mat-error>
                }
              </mat-form-field>
            </div>
            @if (stepThirdFormGroup?.get('userProfile')?.get('birthday')?.hasError('legalAge')) {
              <p class="reelax-red mb-5">
                {{'formErrors.legalAge' | transloco}}
              </p>
            }
            @if (userInfo?.role !== userRole.Anon && specificProcess !== processType.Buying) {
              @if (countries && !!countries.FR) {
                <mat-form-field class="form__field">
                  <mat-label>{{ta('nationality')}}</mat-label>
                  <input
                    #inputCitizenship
                    type="text"
                    name="citizenship"
                    matInput
                    formControlName="citizenship"
                    [matAutocomplete]="auto1"
                    (input)="checkCountry($event)"
                    required
                    autocomplete="new-user-citizenship-select"
                    >
                  @if (!!userProfileForm.value.citizenship) {
                    <button type="button" mat-icon-button matSuffix (click)="cleanNationality()">
                      <mat-icon>close</mat-icon>
                    </button>
                  }
                  <mat-autocomplete autoActiveFirstOption #auto1="matAutocomplete" [displayWith]="displayNationality">
                    @for (c of filteredNationalities | async | keyvalue: nationalityOrder; track c) {
                      <mat-option [value]="c.value" (click)="inputCitizenship.blur()">
                        {{c.value?.nationality}}
                      </mat-option>
                    }
                  </mat-autocomplete>
                  @if (getError('userProfile', 'nationality')) {
                    <mat-error>{{ 'formErrors.' + getError('userProfile', 'nationality') | transloco }}</mat-error>
                  }
                </mat-form-field>
              }
              @if (countries && !!countries.FR) {
                <mat-form-field class="form__field">
                  <mat-label>{{ta('countryOfResidence')}}</mat-label>
                  <input
                    #inputCountry
                    type="text"
                    name="countryOfResidence"
                    matInput
                    formControlName="countryOfResidence"
                    [matAutocomplete]="auto2"
                    (input)="checkCountry($event)"
                    required
                    autocomplete="new-user-countryOfResidence-select"
                    >
                  @if (!!userProfileForm.value.countryOfResidence) {
                    <button type="button" mat-icon-button matSuffix (click)="cleanCountryOfResidence()">
                      <mat-icon>close</mat-icon>
                    </button>
                  }
                  <mat-autocomplete autoActiveFirstOption #auto2="matAutocomplete" [displayWith]="displayCountryName">
                    @for (c of filteredCountryOfResidence | async | keyvalue: countryNameOrder; track c) {
                      <mat-option [value]="c.value" (click)="inputCountry.blur()">
                        {{c.value?.name}}
                      </mat-option>
                    }
                  </mat-autocomplete>
                  @if (getError('userProfile', 'countryOfResidence')) {
                    <mat-error>{{ 'formErrors.' + getError('userProfile', 'countryOfResidence') | transloco }}</mat-error>
                  }
                </mat-form-field>
              }
              @if (stepThirdFormGroup?.value?.userProfile?.countryOfResidence?.code &&
                ['US', 'MX', 'CA'].includes(userProfileForm.value.countryOfResidence?.code)) {
                <app-text-form-field
                  class="form__field --large"
                  [form]="userProfileForm"
                  [controlName]="'region'"
                  [formModel]="userInfo"
                  [validators]="['required']"
                [options]="{
                  label: 'accountInfos.region',
                  hint: 'accountInfos.regionRequiredFor',
                  trim: true
                }"
                />
              }
            }
          </div>
        }

      }

      @if (event?.EventPersonalization?.customBuyerFields) {
        <app-custom-buyer-fields [eventId]="event.id"
        [JSONfields]="event.EventPersonalization.customBuyerFields"/>
      }

      @if (generalConditions) {
        <div formGroupName="generalConditions" class="move-left form">
          <mat-checkbox class="mb-3" name="cgReelax" formControlName="cgReelax" required>
            <p class="checkbox-text">
              {{ ta('iAcceptThe') }}
              <a class="link --custom-event" href="https://reelax-tickets.com/assets/pdf/CGU_reelax.pdf?v=06012025" target="_blank">{{ ta('termsAndConditions') }}</a>
              {{ ta('andThe') }}
              <a class="link --custom-event" href="https://reelax-tickets.com/assets/pdf/PP_reelax.pdf" target="_blank">{{ ta('privacyPolicy') }}</a>
              {{ ta('ofReelaxTickets') }}.<span [matTooltip]="'formErrors.required' | transloco" class="custom-event">&nbsp;*</span>
            </p>
          </mat-checkbox>
          @if (getError('generalConditions', 'cgReelax')) {
            <mat-error class="fs-12">{{ 'formErrors.' + getError('generalConditions', 'cgReelax') | transloco }}</mat-error>
          }
          @if (paymentProviders) {
            @for (pp of paymentProviders; track $index) {
              <mat-checkbox class="mb-3" [name]="pp + 'cg'" [formControlName]="pp + 'cg'" required>
                <p class="checkbox-text">
                  @if (pp === PaymentProviderType.Mangopay) {
                    {{ ta('iAcceptThe') }}
                    <a class="link --custom-event" href="https://reelax-tickets.com/assets/pdf/CGU_mangopay.pdf?v=26112024" target="_blank">
                      {{ ta('termsAndConditions') }}
                    </a>
                    {{ ta('ofMangopay') }}.
                  } @else if (pp === PaymentProviderType.Stripe) {
                    {{ ta('iAcceptThe') }}
                    <a class="link --custom-event" href="https://stripe.com/connect-account/legal">{{ ta('stripeTerms') }}</a>.
                  }
                  <span [matTooltip]="'formErrors.required' | transloco" class="custom-event">&nbsp;*</span>
                </p>
              </mat-checkbox>
              @if (getError('generalConditions', pp + 'cg')) {
                <mat-error class="fs-12">{{ 'formErrors.' + getError('generalConditions', pp + 'cg') | transloco }}</mat-error>
              }
            }
          }
          @if (specificProcess === processType.Selling) {
            <mat-checkbox class="mb-3" name="responsibleUser" formControlName="responsibleUser" required><p class="checkbox-text">{{ ta('iWontSaleSomewhereElse') }}<span [matTooltip]="'formErrors.required' | transloco" class="custom-event">&nbsp;*</span></p></mat-checkbox>
            @if (getError('generalConditions', 'responsibleUser')) {
              <mat-error class="fs-12">{{ 'formErrors.' + getError('generalConditions', 'responsibleUser') | transloco }}</mat-error>
            }
          }
          @if ([processType.WaitList, processType.Selling].includes(specificProcess)) {
            <mat-checkbox class="mb-3" name="commercialCommunication" formControlName="commercialCommunication">
              <p class="checkbox-text">
                {{ optionnalField.customCommercialCommunication?.[currentLang] ??
                optionnalField.customCommercialCommunication?.[Language.frFR] ??
                ta('defaultCommercialCommunicationAgreement')
                }}
              </p>
            </mat-checkbox>
          }
        </div>
      }

      @if (!!formError && !stepThirdFormGroup.valid) {
        <p class="error fs-16 center mt-3">{{ 'formErrors.' + formError | transloco }}</p>
      }

    </form>
  </mat-card-content>
</mat-card>
